import { useEffect } from 'react';

/**
 * Marks html.is-scrolling so CSS can pause GPU-heavy animations
 * and keep wheel/trackpad scrolling on the compositor.
 */
export default function ScrollPerf() {
  useEffect(() => {
    const root = document.documentElement;
    let timer = 0;
    let ticking = false;

    const endScroll = () => {
      root.classList.remove('is-scrolling');
      timer = 0;
    };

    const onScroll = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(() => {
          root.classList.add('is-scrolling');
          ticking = false;
        });
      }
      window.clearTimeout(timer);
      timer = window.setTimeout(endScroll, 150);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('wheel', onScroll, { passive: true });
    window.addEventListener('touchmove', onScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('wheel', onScroll);
      window.removeEventListener('touchmove', onScroll);
      window.clearTimeout(timer);
      root.classList.remove('is-scrolling');
    };
  }, []);

  return null;
}
